/*
 * @Author: 谢树和 shuhe.xie@southgis.com
 * @Date: 2022-09-22 11:23:31
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @LastEditTime: 2022-10-18 09:53:02
 * @FilePath: \standard-v5\src\mixins\comListMixins.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const _finishedText = '没有更多了'
export default {
  data() {
    return {
      refreshConfig: {
        loading: false,
        finished: false,
        finishedText: '',
        error: false,
        errorText: '请求失败，点击重新加载',
        refreshing: false,
        curPage: 0
      }
    }
  },
  methods: {
    onRefresh() {
      console.log('comlist-onRefresh')
      this.refreshConfig.finished = false
      let nextPage = 1
      let data = {
        page: nextPage,
        rows: 20
        // userid: this.$store.state.userInfo.id
      }
      this.refreshConfig.loading = true
      this._loadData(data).then(res => {
        this.refreshConfig.refreshing = false
        // this.refreshConfig.curPage = nextPage
      })
    },
    loadData(data) {
      // 对应Vue实例重写
    },
    _loadData(data) {
      return this.loadData(data)
        .then(res => {
          let list = res.data.rowsList
          // console.log('resss', res)
          this.refreshConfig.curPage = data.page
          if (list.length == 0 && data.page == 1) {
            // this.refreshConfig.finished = false;
            this.refreshConfig.finishedText = ''
          } else {
            this.refreshConfig.finishedText = _finishedText
          }
          if (list.length < data.rows) {
            this.refreshConfig.finished = true
          }
          this.refreshConfig.loading = false
          return Promise.resolve(res)
        })
        .catch(err => {
          this.refreshConfig.error = true
        })
    },
    onLoad() {
      console.log('comlist-onLoad')
      let nextPage = this.refreshConfig.curPage + 1
      let data = {
        page: nextPage,
        rows: 20
        // userid: this.$store.state.userInfo.id
      }
      this._loadData(data).then(res => {
        this.refreshConfig.refreshing = false
        // this.refreshConfig.curPage = nextPage
      })
    }
  }
}
